import scrollLock from 'scroll-lock';

let logos = null;
let menu = null;
let header = null;

export default {
	name: 'home',
	to: {
		namespace: ['home'],
	},
	beforeOnce: ({ current, next, trigger }) => {
		next.container.classList.add('home--before-animation');
		header = document.querySelector('.c-header--frontpage');
		logos = header.querySelector('.c-header__logos');
		menu = header.querySelector('.c-header-menu');

		scrollLock.disablePageScroll();

		setTimeout(() => {
			scrollLock.enablePageScroll();
			next.container.classList.add('home--after-animation');
		}, 2200);

	},
	once: ({ current, next, trigger }) => {
		setTimeout(function() {
			logos.classList.add('c-header__logos--visible');
			menu.classList.add('c-header-menu--visible');
			next.container.classList.add('home--visible');
		}, 10);
	},
};
